import { initSearch } from "./initSearch";
import { organizeFamiliesByGroups } from "./organizeFamiliesByGroups";
export function listGroups({ families }) {
    window.families = families;
    window.groups = organizeFamiliesByGroups(families);
    initSearch();
}
